import { ActionTree } from 'vuex';
import { FiltersState, RootState } from '../types';
import { getDefaultDietOptions, getDefaultAllergenOptions } from './filters';
import { fireGoogleTag } from '@/utils/google-tag-manager-helpers';

export const actions: ActionTree<FiltersState, RootState> = {
	setAvailableFilters({ commit, rootGetters, state }): void {
		// Rebuild from the defaults so labels use the locale resolved for the restaurant, carrying over any selection already made
		const isSelected = (options: FilterTag[], value: string): boolean => options.some((option: FilterTag) => option.value === value && option.selected);
		const availableDiets = getDefaultDietOptions()
			.filter((dietOption: FilterTag) => rootGetters['restaurant/getAvailableDiets'].includes(dietOption.value))
			.map((dietOption: FilterTag) => ({ ...dietOption, selected: isSelected(state.dietOptions, dietOption.value) }));
		const availableAllergens = getDefaultAllergenOptions()
			.filter((allergenOption: FilterTag) => rootGetters['restaurant/getAvailableAllergens'].includes(allergenOption.value))
			.map((allergenOption: FilterTag) => ({ ...allergenOption, selected: isSelected(state.allergenOptions, allergenOption.value) }));

		commit('SET_FILTERS', {
			diets: availableDiets,
			allergens: availableAllergens
		});
	},

	toggleDiet({ commit }, index: number): void {
		fireGoogleTag({ name: 'filterApplied', detail: 'diet' });
		commit('TOGGLE_DIET', index);
	},

	toggleAllergens({ commit }, index: number): void {
		fireGoogleTag({ name: 'filterApplied', detail: 'allergen' });
		commit('TOGGLE_ALLERGENS', index);
	},

	clearFilters({ commit }): void {
		fireGoogleTag({ name: 'filterApplied', detail: 'clear' });
		commit('CLEAR_SELECTED_FILTERS');
	}
};